import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useForm, useWatch } from "react-hook-form";
import Breadcrumb from '../../../components/layout/Breadcrumb';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function ChecklistApproval() {
    const navigate = useNavigate();
    const location = useLocation();
    const {
        register, handleSubmit, onSubmit, reset, formState: { errors }, control, getValues
    } = useForm();
    const [formKey, setFormKey] = useState(0);
    const checklist = ["Assets Return", "VPN Access Removed", "Finance Clearance", "Project Handover", "Resignation Approval From Manager"]

    // for post btn conditionally disabled
    const checkboxValues = useWatch({
        control,
        name: checklist.map(item => `checkboxApprovalForResignation.${item}`),
    });

    const allChecked = checkboxValues?.every(val => val === true);
    const hasErrors = Object.keys(errors).length > 0;

    const proceedChecklistDisabled = !allChecked || hasErrors;

    const handleFormSubmit = async (data) => {
        if (Object.keys(errors).length > 0) {
            return;
        }
        onSubmit(data);
        reset({
            checkboxApprovalForResignation: checklist.reduce((acc, item) => {
                acc[item] = false; // each checkbox is set to unchecked
                return acc;
            }, {}) // start with an empty object
        });
        setTimeout(() => {
            navigate('/admin/offboarded/final-clearance', {
                state: {
                    breadcrumbTrail: [
                        ...(location.state?.breadcrumbTrail || []),
                        { name: 'FinalClearance', path: '/admin/offboarded/final-clearance' }
                    ]
                }
            });
        }, 2000);
        toast.success("Checklist submitted successfully.Proceeding to the next step...");
    };

    const handleCancelChecklist = () => {
        const { checkboxApprovalForResignation = {} } = getValues();
        const isFormEmpty = Object.values(checkboxApprovalForResignation).every(val => !val);
        if (isFormEmpty) {
            navigate('/admin/offboarded/schedule-meeting'); // navigate if empty
        } else {
            reset();
            setFormKey(prev => prev + 1);
        }
    };

    return (
        <div className='container-fluid'>
            <div className='row clearfix'>
                <div className='col-md-12'>
                    <Breadcrumb />
                    <div className='attendance-container' style={{ padding: '0', marginBottom: '45px', marginTop: '34px' }}>
                        <form key={formKey} onSubmit={handleSubmit(handleFormSubmit)}>
                            <h4 className='apply-leave-heading'>Checklist</h4>
                            <p style={{ marginTop: '-13px' }}>Ensure all checklist items are completed before proceeding</p>
                            <div className='apply-leave-section' style={{ marginBottom: '15px' }}>
                                <div className="input-text">
                                    <div className="user-input-icons">
                                        {checklist.map((item) => (
                                            <div key={item.id} style={{ marginBottom: '8px' }}>
                                                <label>
                                                    <input
                                                        type="checkbox"
                                                        {...register(`checkboxApprovalForResignation.${item}`)} />
                                                    {item}
                                                </label>
                                            </div>
                                        ))}
                                        <div style={{ display: 'flex', justifyContent: 'center', gap: '15px' }}>
                                            <button className="primary-btn" type='button' style={{ background: 'darkgray', width: '100px' }} onClick={() => handleCancelChecklist()}>Cancel</button>
                                            <button className="primary-btn" type="submit" style={{ width: '100px' }}
                                                disabled={proceedChecklistDisabled}
                                            >Next</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <ToastContainer />
        </div >
    )
}
